import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "products-list__loader loader",
  role: "progressbar"
}
const _hoisted_3 = {
  key: 0,
  role: "listitem",
  class: "products-list__element products-list__element--type_insertion"
}
const _hoisted_4 = {
  key: 1,
  class: "slot-insertion teaser-in-column grid"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_template = _resolveComponent("dynamic-template")!

  return (_ctx.elementsList)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["products-list", _ctx.listClasses]),
        role: "list",
        "aria-label": _ctx.productListStore?.currentCategory?.name
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createTextVNode()),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementsList.elements, (element, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `${index}-${_ctx.getId(element)}`
          }, [
            (_ctx.hasInsertionRow(index))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.useInitialSlots && _ctx.slotExists(`slot-insertion-${_ctx.insertionIndex(index)}`))
                    ? _renderSlot(_ctx.$slots, `slot-insertion-${_ctx.insertionIndex(index)}`, { key: 0 })
                    : (!_ctx.useInitialSlots)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_dynamic_template, {
                            html: _ctx.getInsertionHtml(index)
                          }, null, 8 /* PROPS */, ["html"])
                        ]))
                      : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _cache[0] || (_cache[0] = _createTextVNode()),
            (element.type === 'product' || element.type === 'product-wishlist')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  role: "listitem",
                  "aria-label": element.data.name,
                  class: _normalizeClass({
          [`products-list__element products-list__element--type_${element.type}`]: true,
        })
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getProductBoxComponent(element.data)), {
                    class: "products-list__product-box",
                    "product-box-data": element.data,
                    "hide-counter-button": false,
                    state: _ctx.productStates.get(element.data.itemId),
                    "tracking-additional": {
            position: index,
            list: _ctx.trackingList
          },
                    "lazy-load": true,
                    onAddToBasket: _ctx.addToBasket,
                    onAddToWishlist: _ctx.onAddToWishlist,
                    onRemoveFromWishlist: _ctx.onRemoveFromWishlist,
                    onQuantityChange: _ctx.onQuantityChange
                  }, null, 40 /* PROPS, NEED_HYDRATION */, ["product-box-data", "state", "tracking-additional", "onAddToBasket", "onAddToWishlist", "onRemoveFromWishlist", "onQuantityChange"]))
                ], 10 /* CLASS, PROPS */, _hoisted_5))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "products-list__no-products",
        innerHTML: _ctx.$t('productlist.no_products')
      }, null, 8 /* PROPS */, _hoisted_6))
}